// utils/kitHelpers.js
import { supabase } from "../lib/supabase";

export async function deleteKitIfNoCases(kitId) {
	// Check for associated cases
	const { data: caseLinks, error: caseError } = await supabase
		.from("kit_cases")
		.select("id")
		.eq("kit_id", kitId);

	if (caseError) {
		console.error("Failed to check kit associations:", caseError);
		return {
			success: false,
			message: "Failed to check for associated cases.",
		};
	}

	if (caseLinks && caseLinks.length > 0) {
		return {
			success: false,
			message: "You must remove all cases from this kit before deleting.",
		};
	}

	// Proceed with deletion
	const { error: deleteError } = await supabase
		.from("kits")
		.delete()
		.eq("id", kitId);

	if (deleteError) {
		console.error("Kit deletion failed:", deleteError);
		return { success: false, message: "Failed to delete kit." };
	}

	return { success: true };
}
